import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../constants/apiConstants';
import axiosInstance from '../api/axios';

// projection date object interface
interface ProjectionDate {
  projectionstartdate: string;
}

// projection dates array interface
interface ProjectionDates {
  projectiondatelist: ProjectionDate[];
}

// slice Initial state interface
interface ProjectionDatesState {
  dashboardDates: ProjectionDate[];
  error: string | null;
  loading: boolean;
}

// Initial state
const initialState: ProjectionDatesState = {
  dashboardDates: [],
  error: null,
  loading: false
};

// async thunk for API call
export const fetchDasboardDates = createAsyncThunk<ProjectionDates, { userId: string | null, modulecode: string }>(
  'projections/GetDashboardDates',
  async ({ userId, modulecode }) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuProjection/GetDashboardDates`, {
      userid: userId, modulecode
    });

    // Check if the API response
    if (response.data.success) {
      return response.data.data as ProjectionDates; // Return only the data part
    } else {
      throw new Error(response.data.errormessage || 'Failed to fetch projection dates');
    }
  }
);

// slice
const dashboardDatesSlice = createSlice({
  name: 'dashboardDates',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDasboardDates.fulfilled, (state, action) => {
        state.dashboardDates = action.payload.projectiondatelist;
        state.loading = false;

      })
      .addCase(fetchDasboardDates.rejected, (state, action) => {
        state.error = action.error.message || 'Error fetching projection dates';
        state.loading = false;
      });
  },
});

export default dashboardDatesSlice.reducer;
